import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      gridArea: "pageContent",
      minWidth: 0,
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
      }
    },
    stretch: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1
    },
    noPadding: {
      padding: 0
    }
  }),
  { name: "BackstageContent" }
);
function Content(props) {
  const { className, stretch, noPadding, children, ...restProps } = props;
  const classes = useStyles();
  return /* @__PURE__ */ jsx(
    "article",
    {
      ...restProps,
      className: classNames(classes.root, className, {
        [classes.stretch]: stretch,
        [classes.noPadding]: noPadding
      }),
      children
    }
  );
}

export { Content };
//# sourceMappingURL=Content.esm.js.map
